import { render, staticRenderFns } from "./MediaPackageForm.vue?vue&type=template&id=785340c6&"
import script from "./MediaPackageForm.vue?vue&type=script&lang=ts&"
export * from "./MediaPackageForm.vue?vue&type=script&lang=ts&"
import style0 from "./MediaPackageForm.vue?vue&type=style&index=0&id=785340c6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports